export default "__VITE_ASSET__71ebEoPZ__"